import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { EmergencyBolComponent } from './emergency-bol.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { HeaderModule } from '../../header/header.module';
import { SidemenuModule } from '../../sidemenu/sidemenu.module';
import { FooterModule } from '../../footer/footer.module';
import { UploadModule } from '../upload/upload.module';

@NgModule({
  declarations: [EmergencyBolComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule,
    NgxMaterialTimepickerModule,
    HeaderModule,
    SidemenuModule,
    FooterModule,
    UploadModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    RouterModule.forChild([
      {
        path: "",
        component: EmergencyBolComponent
      }
    ])
  ],
  providers:[DatePipe],
  
})
export class EmergencyBolModule { }
